import { omitKeys } from "@hex-insights/core";
import { Address, Country, Person } from "../../../Utilities";

export type Base = {
	name: Address["name"];
	addressLine1: Address["addressLine1"];
	addressLine2: Address["addressLine2"];
	city: Address["city"];
	postalCode: Address["postalCode"];
	stateOrProvince: Address["stateOrProvince"];
	countryID: Country["id"] | null;
	personIDs: Person["id"][];
};

export type Create = Base;

export type CreateRequiredKey = Extract<keyof Create, "addressLine1" | "city" | "postalCode" | "countryID">;

export type CreateSubset<K extends keyof Create = keyof Create> = Pick<Create, CreateRequiredKey | K>;

export const initialCreate: Create = {
	name: "",
	addressLine1: "",
	addressLine2: "",
	city: "",
	postalCode: "",
	stateOrProvince: "",
	countryID: null,
	personIDs: [],
};

export type Detail = Base;

export type DetailSubset<K extends keyof Detail = keyof Detail> = Pick<Detail, K>;

// Custom:

export type CreateInPerson = Omit<Create, "personIDs">;

export type CreateInPersonRequiredKey = Exclude<CreateRequiredKey, "personIDs">;

export type CreateInPersonSubset<K extends keyof CreateInPerson = keyof CreateInPerson> = Pick<
	CreateInPerson,
	CreateInPersonRequiredKey | K
>;

export const blankItemInPerson: CreateInPerson = omitKeys(initialCreate, ["personIDs"]);
